export const messages = {
  appTitle: "Veilederen – Spillet",
  loginTitle: "Logg inn for å spille",
  loginBody: "Du logger inn med Visma Connect for å øve på realistiske caser fra Veilederen.",
  loginButton: "Logg inn med Visma Connect",
  loginBusy: "Logger inn …",
  loginError: "Innloggingen feilet. Prøv igjen.",
  logout: "Logg ut",
  chooseDifficulty: "Velg vanskelighetsgrad",
  easy: "Lett",
  medium: "Middels",
  hard: "Krevende",
  startCase: "Start case",
  loadingCase: "Henter case …",
  noCases: "Ingen aktive caser er klare for denne vanskelighetsgraden ennå.",
  yourArgument: "Ditt argument",
  argumentPlaceholder: "Skriv hvordan du vil løse situasjonen, med henvisning til regelverket.",
  sendArgument: "Send argument",
  requestHint: "Be om hint",
  understanding: "Forståelse",
  sessionComplete: "Caset er løst",
  playAgain: "Spill et nytt case",
  referenceFeedback: "Tilbakemelding",
  hintLabel: "Hint",
  sending: "Sender …",
  authRequired: "Du må være innlogget for å spille.",
  genericError: "Noe gikk galt. Prøv igjen.",
  callbackBusy: "Fullfører innlogging …",
} as const;

export type MessageKey = keyof typeof messages;
